export const ADD_PHOTO_URL_DEFAULT: string =
  "https://us.123rf.com/450wm/tvectoricons/tvectoricons1811/tvectoricons181105271/112229760-add-photos-icon-trendy-flat-vector-add-photos-icon-on-white-background-from-general-collection.jpg?ver=6";

export const CURP_REGEX: RegExp =
  /[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}/i;

export const GUID_ZERO = "00000000-0000-0000-0000-000000000000";
